<div class="vehicle-row" *ngIf="vehicle && config">
    <div class="content">

        <ng-container *ngFor="let type of config.VehicleFullListColumnsOrder">

            <!-- { Type: 13, Name: 'Status' }, -->
            <!-- dane z czujnika -->
            <div class="field-column status" *ngIf="showColumn(13) && type===13">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [vehicle]="vehicle" [group]="13">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 2, Name: 'Czas' }, -->
            <!-- czas od ostatniej aktualizacji czujnika -->
            <div class="field-column time" *ngIf="showColumn(2) && type===2">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="2">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 11, Name: 'Pojazd' }, -->
            <!-- nazwa samocodu -->
            <div class="field-column name" *ngIf="showColumn(11) && type===11" [title]="vehicle.Nm">
                <div class="field-column-content">
                    {{ vehicle.Nm }}
                </div>
            </div>

            <!-- { Type: 12, Name: 'Prędkość' }, -->
            <div class="field-column speed" *ngIf="showColumn(12) && type===12">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="12">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 1, Name: 'Adres' }, -->
            <div class="field-column location" *ngIf="showColumn(1) && type===1">
                <div class="field-column-content">
                    <tk-vehicle-location [location]="vehicle.LL"></tk-vehicle-location>
                </div>
            </div>

            <!-- { Type: 4, Name: 'Kierowca' }, -->
            <div class="field-column driver" *ngIf="showColumn(4) && type===4">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [driver]="driver" [group]="4">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 19, Name: 'eToll' }, -->
            <div class="field-column etoll" *ngIf="showColumn(19) && type===19">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [vehicle]="vehicle" [group]="19">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 14, Name: 'Sygnał GPS' }, -->
            <div class="field-column gps" *ngIf="showColumn(14) && type===14">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="14">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 15, Name: 'Sygnał GSM' }, -->
            <div class="field-column gsm" *ngIf="showColumn(15) && type===15">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="15">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 8, Name: 'Paliwo' }, -->
            <div class="field-column fuel" *ngIf="showColumn(8) && type===8">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [fuel]="fuel!" [group]="8">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 7, Name: 'Obroty' }, -->
            <div class="field-column rpm" *ngIf="showColumn(7) && type===7">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="7">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 17, Name: 'Temperatura' }, -->
            <div class="field-column temperature" *ngIf="showColumn(17) && type===17">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="17">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 3, Name: 'Czujniki' }, -->
            <div class="field-column indicators" *ngIf="showColumn(3) && type===3">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="3" [options]="options">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <div class="field-column indicators" *ngIf="showColumn(3) && isIndictorColumnFullOn === true && type===3"
                [ngClass]="{'field-column-content-full-length': isIndictorColumnFullOn}"
                [ngStyle]="{'min-width.px' : indictorColumnFullMinWidth, 'left.px' : indictorColumnFullLeft }">
                <div class="field-column-content">
                    <div>
                        <tk-vehicle-control-indicator-value [params]="params" [group]="3" [options]="options">
                        </tk-vehicle-control-indicator-value>
                    </div>
                </div>
            </div>


            <!-- { Type: 16, Name: 'Tachograf' }, -->
            <ng-container *ngIf="showColumn(16) && type===16">
                <!-- tu bedzie kilka elementow tacho -->
                <div class="field-column column-block tacho" *ngIf="showTachoColumn()">
                    <div class="field-column-content">
                        <tk-vehicle-control-indicator-value [tacho]="vehicle.Tacho" [params]="params" [group]="16"
                            [options]="options"></tk-vehicle-control-indicator-value>
                    </div>
                </div>

                <div class="field-column column-block tacho" *ngIf="showTachoColumn('driving')">
                    <div class="field-column-content">
                        <tk-vehicle-control-indicator-value [tacho]="vehicle.Tacho" [params]="params" [group]="16"
                            [options]="options" category="driving"></tk-vehicle-control-indicator-value>
                    </div>
                </div>
                <div class="field-column column-block tacho" *ngIf="showTachoColumn('working')">
                    <div class="field-column-content">
                        <tk-vehicle-control-indicator-value [tacho]="vehicle.Tacho" [params]="params" [group]="16"
                            [options]="options" category="working"></tk-vehicle-control-indicator-value>
                    </div>
                </div>
                <div class="field-column column-block tacho" *ngIf="showTachoColumn('resting')">
                    <div class="field-column-content">
                        <tk-vehicle-control-indicator-value [tacho]="vehicle.Tacho" [params]="params" [group]="16"
                            [options]="options" category="resting"></tk-vehicle-control-indicator-value>
                    </div>
                </div>
                <div class="field-column column-block tacho" *ngIf="showTachoColumn('free')">
                    <div class="field-column-content">
                        <tk-vehicle-control-indicator-value [tacho]="vehicle.Tacho" [params]="params" [group]="16"
                            [options]="options" category="free"></tk-vehicle-control-indicator-value>
                    </div>
                </div>

            </ng-container>

            <!-- { Type: 5, Name: 'Licznik km' }, -->
            <div class="field-column km-counter" *ngIf="showColumn(5) && type===5">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="5">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 6, Name: 'Napięcie' }, -->
            <div class="field-column power" *ngIf="showColumn(6) && type===6">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="6">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 9, Name: 'Paliwo CAN' },
            <div class="field-column can-fuel" *ngIf="showColumn(9) && type===9">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="9">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>
            -->

            <!-- { Type: 10, Name: 'Pedał gazu' }, -->
            <div class="field-column accelerator" *ngIf="showColumn(10) && type===10">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="10">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

            <!-- { Type: 18, Name: 'Zuzycie CAN' }, -->
            <div class="field-column can-fual-usage" *ngIf="showColumn(18) && type===18">
                <div class="field-column-content">
                    <tk-vehicle-control-indicator-value [params]="params" [group]="18">
                    </tk-vehicle-control-indicator-value>
                </div>
            </div>

        </ng-container>
    </div>
</div>